import { GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE } from "../const";
import type { GrowthOverviewResponse } from "../growthOverviewApiTypes";
import { GrowthOverviewLevel } from "../types";

export interface IGrowthOverviewPaginationParams {
    industryOffset?: number;
    industryLimit?: number;
    subIndustryOffset?: number;
    subIndustryLimit?: number;
}

const clampPage = <T>(items: readonly T[], offset: number, limit: number): T[] => {
    if (items.length <= limit) {
        return [...items];
    }

    return items.slice(offset, offset + limit);
};

export const clampPaginatedGrowthOverviewResponse = (
    response: GrowthOverviewResponse,
    pagination: IGrowthOverviewPaginationParams = {},
): GrowthOverviewResponse => {
    if (response.level === GrowthOverviewLevel.Industries) {
        const offset = pagination.industryOffset ?? 0;
        const limit = pagination.industryLimit ?? GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE;
        const industries = response.industries ?? [];
        const clampedIndustries = clampPage(industries, offset, limit);

        if (clampedIndustries.length === industries.length) {
            return response;
        }

        return {
            ...response,
            industries: clampedIndustries,
        };
    }

    if (response.level === GrowthOverviewLevel.SubIndustries) {
        const offset = pagination.subIndustryOffset ?? 0;
        const limit = pagination.subIndustryLimit ?? GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE;
        const subIndustries = response.subIndustries ?? [];
        const clampedSubIndustries = clampPage(subIndustries, offset, limit);

        if (clampedSubIndustries.length === subIndustries.length) {
            return response;
        }

        return {
            ...response,
            subIndustries: clampedSubIndustries,
        };
    }

    return response;
};
